<div class="bg-nz-primary text-white py-4">
  <div class="container-lg">
    <section class="mb-4 text-center">
      <nz-logo height="70" mode="monochromatic-light"/>
    </section>
    <nav>
      <ul class="list-unstyled d-flex justify-content-center flex-wrap">
        @for (item of items; track item) {
          <li>
            <a [routerLink]="item.route"
               [attr.aria-label]="item.title"
               class="btn btn-link text-white text-decoration-none">
              {{ item.title }}
            </a>
          </li>
        }
      </ul>
    </nav>
    <hr class="my-3 border-light">
    <section class="d-flex justify-content-center flex-wrap gap-1">
      <small>&copy; 2023 - 2025 Нумизмат ЕООД.</small>
      <small>Всички права запазени.</small>
    </section>
  </div>
</div>
